import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CreateClaimantType } from '@/domains/claimants/store/types/createClaimantSliceTypes';
import {
  CreateNoteFieldKey,
  CreateNoteFieldValue,
  CreateNotePayload,
  CreateNoteSliceState,
  DocumentsFromEntitiesPayload,
  EditNotePayload,
} from '@/domains/notes/store/types/createNoteTypes';
import { GetNoteListPayload } from '@/domains/notes/store/types/noteTypes';
import { SelectOption } from '@/features/editMode/types/selectOption';
import { DocumentEntityTypeId } from '@/domains/documents/enums/DocumentEntityTypeId';
import { createNoteInitialState } from '@/domains/notes/store/constants/createNoteSliceConstants';

const createNoteSlice = createSlice({
  name: 'createNote',
  initialState: createNoteInitialState,
  reducers: {
    getEntityDocumentOptionEntitiesSuccess: (
      state,
      {
        payload: { entityType, entities },
      }: PayloadAction<{ entities: SelectOption[]; entityType: DocumentEntityTypeId }>,
    ) => {
      const entityOptions = state.entityDocumentOptions[entityType] || { documents: [] };
      state.entityDocumentOptions[entityType] = { ...entityOptions, entities };
    },
    getDocumentsFromEntities: (_, _action: PayloadAction<GetNoteListPayload>) => {},
    getDocumentsFromEntitiesSuccess: (
      state,
      { payload: { entityType, documents } }: PayloadAction<DocumentsFromEntitiesPayload>,
    ) => {
      const entityOptions = state.entityDocumentOptions[entityType] || { entities: [] };
      state.entityDocumentOptions[entityType] = { ...entityOptions, documents };
    },
    setDocumentOptionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.areDocumentsLoading = payload;
    },
    setOptionsAreLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isLoading = payload;
    },
    changeCreateDocumentType: (state, { payload }: PayloadAction<CreateClaimantType>) => {
      state.createDocumentType = payload;
    },
    getClaimSetDocuments: () => {},
    updateCreateNoteStepValues: <K extends CreateNoteFieldKey>(
      state: CreateNoteSliceState,
      action: PayloadAction<{ step: K; value: CreateNoteFieldValue<K> }>,
    ) => {
      const { step, value } = action.payload;
      state.createNoteSteps[step] = value;
    },
    createNote: (_, _action: PayloadAction<CreateNotePayload>) => {},
    editNote: (_, _action: PayloadAction<EditNotePayload>) => {},
    resetCreateNoteState: () => createNoteInitialState,
  },
});

export const {
  setDocumentOptionsLoading,
  setOptionsAreLoading,
  changeCreateDocumentType,
  getDocumentsFromEntities,
  getDocumentsFromEntitiesSuccess,
  getClaimSetDocuments,
  updateCreateNoteStepValues,
  createNote,
  editNote,
  resetCreateNoteState,
  getEntityDocumentOptionEntitiesSuccess,
} = createNoteSlice.actions;

export const createNoteReducer = createNoteSlice.reducer;
export const createNoteReducerPath = createNoteSlice.reducerPath;
